/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.DocumentTypeRelevanceTransactionTypeMapping_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.DocumentTypeRelevanceTransactionTypeMapping domain view...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum DocumentTypeRelevanceTransactionTypeMapping_ {
   /// <summary>
   ///   Agency Agreement (3)
   /// </summary>
   Buyer_AgencyAgreement_3 = 3,
   /// <summary>
   ///   Agency Agreement (4)
   /// </summary>
   Tenant_AgencyAgreement_4 = 4,
   /// <summary>
   ///   Agency Agreement (5)
   /// </summary>
   Buyer_AgencyAgreement_5 = 5,
   /// <summary>
   ///   Agency Agreement (6)
   /// </summary>
   Buyer_AgencyAgreement_6 = 6,
   /// <summary>
   ///   Sales Contract (7)
   /// </summary>
   Buyer_SalesContract_7 = 7,
   /// <summary>
   ///   MLS Listing Sheet (8)
   /// </summary>
   Buyer_MlsListingSheet_8 = 8,
   /// <summary>
   ///   Referral Fee Agreement (9)
   /// </summary>
   Buyer_ReferralFeeAgreement_9 = 9,
   /// <summary>
   ///   Signed Disclosures (10)
   /// </summary>
   Buyer_SignedDisclosures_10 = 10,
   /// <summary>
   ///   Price Changes (11)
   /// </summary>
   Buyer_PriceChanges_11 = 11,
   /// <summary>
   ///   Earnest Money Check (12)
   /// </summary>
   Buyer_EarnestMoneyCheck_12 = 12,
   /// <summary>
   ///   Commission Check/DA (13)
   /// </summary>
   Buyer_CommissionCheck_13 = 13,
   /// <summary>
   ///   Settlement Statement (14)
   /// </summary>
   Buyer_SettlementStatement_14 = 14,
   /// <summary>
   ///   MLS Listing Sheet (15)
   /// </summary>
   Tenant_MlsListingSheet_15 = 15,
   /// <summary>
   ///   Mutual Cancellation Agreement (16)
   /// </summary>
   Tenant_MutualCancellationAgreement_16 = 16,
   /// <summary>
   ///   Sales Contract (17)
   /// </summary>
   Tenant_SalesContract_17 = 17,
   /// <summary>
   ///   Referral Fee Agreement (18)
   /// </summary>
   Tenant_ReferralFeeAgreement_18 = 18,
   /// <summary>
   ///   Signed Disclosures (19)
   /// </summary>
   Tenant_SignedDisclosures_19 = 19,
   /// <summary>
   ///   Price Changes (20)
   /// </summary>
   Tenant_PriceChanges_20 = 20,
   /// <summary>
   ///   Settlement Statement (21)
   /// </summary>
   Tenant_SettlementStatement_21 = 21,
   /// <summary>
   ///   Commission Check/DA (22)
   /// </summary>
   Tenant_CommissionCheck_22 = 22,
   /// <summary>
   ///   Earnest Money Check (23)
   /// </summary>
   Tenant_EarnestMoneyCheck_23 = 23,
   /// <summary>
   ///   Sales Contract (24)
   /// </summary>
   Buyer_SalesContract_24 = 24,
   /// <summary>
   ///   Signed Disclosures (25)
   /// </summary>
   Buyer_SignedDisclosures_25 = 25,
   /// <summary>
   ///   Settlement Statement (26)
   /// </summary>
   Buyer_SettlementStatement_26 = 26,
   /// <summary>
   ///   Commission Check/DA (27)
   /// </summary>
   Buyer_CommissionCheck_27 = 27,
   /// <summary>
   ///   Referral Fee Agreement (28)
   /// </summary>
   Buyer_ReferralFeeAgreement_28 = 28,
   /// <summary>
   ///   Price Changes (29)
   /// </summary>
   Buyer_PriceChanges_29 = 29,
   /// <summary>
   ///   Earnest Money Check (30)
   /// </summary>
   Buyer_EarnestMoneyCheck_30 = 30,
   /// <summary>
   ///   Sales Contract (31)
   /// </summary>
   Buyer_SalesContract_31 = 31,
   /// <summary>
   ///   Referral Fee Agreement (32)
   /// </summary>
   Buyer_ReferralFeeAgreement_32 = 32,
   /// <summary>
   ///   Signed Disclosures (33)
   /// </summary>
   Buyer_SignedDisclosures_33 = 33,
   /// <summary>
   ///   Price Changes (34)
   /// </summary>
   Buyer_PriceChanges_34 = 34,
   /// <summary>
   ///   Settlement Statement (35)
   /// </summary>
   Buyer_SettlementStatement_35 = 35,
   /// <summary>
   ///   Commission Check/DA (36)
   /// </summary>
   Buyer_CommissionCheck_36 = 36,
   /// <summary>
   ///   Earnest Money Check (37)
   /// </summary>
   Buyer_EarnestMoneyCheck_37 = 37,
   /// <summary>
   ///   Mutual Cancellation Agreement (38)
   /// </summary>
   Buyer_MutualCancellationAgreement_38 = 38,
   /// <summary>
   ///   Lease Agreement (39)
   /// </summary>
   Tenant_LeaseAgreement_39 = 39,
   /// <summary>
   ///   MLS Listing Sheet (40)
   /// </summary>
   Tenant_MlsListingSheet_40 = 40,
   /// <summary>
   ///   Commission Check/DA (41)
   /// </summary>
   Tenant_CommissionCheck_41 = 41,
   /// <summary>
   ///   Referral Fee Agreement (42)
   /// </summary>
   Tenant_ReferralFeeAgreement_42 = 42,
   /// <summary>
   ///   Signed Disclosures (43)
   /// </summary>
   Tenant_SignedDisclosures_43 = 43,
   /// <summary>
   ///   Lease Agreement (47)
   /// </summary>
   Tenant_LeaseAgreement_47 = 47,
   /// <summary>
   ///   Lease Agreement (50)
   /// </summary>
   Tenant_LeaseAgreement_50 = 50,
   /// <summary>
   ///   Commission Check/DA (51)
   /// </summary>
   Tenant_CommissionCheck_51 = 51,
   /// <summary>
   ///   Referral Fee Agreement (52)
   /// </summary>
   Tenant_ReferralFeeAgreement_52 = 52,
   /// <summary>
   ///   Signed Disclosures (53)
   /// </summary>
   Tenant_SignedDisclosures_53 = 53,
   /// <summary>
   ///   Lease Agreement (54)
   /// </summary>
   Tenant_LeaseAgreement_54 = 54,
   /// <summary>
   ///   Mutual Cancellation Agreement (55)
   /// </summary>
   Tenant_MutualCancellationAgreement_55 = 55,
   /// <summary>
   ///   Referral Fee Agreement (56)
   /// </summary>
   Tenant_ReferralFeeAgreement_56 = 56,
   /// <summary>
   ///   Signed Disclosures (57)
   /// </summary>
   Tenant_SignedDisclosures_57 = 57,
   /// <summary>
   ///   Commission Check/DA (58)
   /// </summary>
   Tenant_CommissionCheck_58 = 58,
   /// <summary>
   ///   Additional Files (59)
   /// </summary>
   Buyer_AdditionalFiles_59 = 59,
   /// <summary>
   ///   Additional Files (60)
   /// </summary>
   Tenant_AdditionalFiles_60 = 60,
   /// <summary>
   ///   Additional Files (61)
   /// </summary>
   Buyer_AdditionalFiles_61 = 61,
   /// <summary>
   ///   Additional Files (62)
   /// </summary>
   Buyer_AdditionalFiles_62 = 62,
   /// <summary>
   ///   Additional Files (63)
   /// </summary>
   Tenant_AdditionalFiles_63 = 63,
   /// <summary>
   ///   Additional Files (65)
   /// </summary>
   Tenant_AdditionalFiles_65 = 65,
   /// <summary>
   ///   Additional Files (66)
   /// </summary>
   Tenant_AdditionalFiles_66 = 66,
   /// <summary>
   ///   Agency Agreement (67)
   /// </summary>
   Seller_AgencyAgreement_67 = 67,
   /// <summary>
   ///   Agency Agreement (68)
   /// </summary>
   Seller_AgencyAgreement_68 = 68,
   /// <summary>
   ///   Agency Agreement (69)
   /// </summary>
   Seller_AgencyAgreement_69 = 69,
   /// <summary>
   ///   Sales Contract (70)
   /// </summary>
   Seller_SalesContract_70 = 70,
   /// <summary>
   ///   MLS Listing Sheet (71)
   /// </summary>
   Seller_MlsListingSheet_71 = 71,
   /// <summary>
   ///   Referral Fee Agreement (72)
   /// </summary>
   Seller_ReferralFeeAgreement_72 = 72,
   /// <summary>
   ///   Signed Disclosures (73)
   /// </summary>
   Seller_SignedDisclosures_73 = 73,
   /// <summary>
   ///   Price Changes (74)
   /// </summary>
   Seller_PriceChanges_74 = 74,
   /// <summary>
   ///   Earnest Money Check (75)
   /// </summary>
   Seller_EarnestMoneyCheck_75 = 75,
   /// <summary>
   ///   Commission Check/DA (76)
   /// </summary>
   Seller_CommissionCheck_76 = 76,
   /// <summary>
   ///   Settlement Statement (77)
   /// </summary>
   Seller_SettlementStatement_77 = 77,
   /// <summary>
   ///   Sales Contract (78)
   /// </summary>
   Seller_SalesContract_78 = 78,
   /// <summary>
   ///   Signed Disclosures (79)
   /// </summary>
   Seller_SignedDisclosures_79 = 79,
   /// <summary>
   ///   Settlement Statement (80)
   /// </summary>
   Seller_SettlementStatement_80 = 80,
   /// <summary>
   ///   Commission Check/DA (81)
   /// </summary>
   Seller_CommissionCheck_81 = 81,
   /// <summary>
   ///   Referral Fee Agreement (82)
   /// </summary>
   Seller_ReferralFeeAgreement_82 = 82,
   /// <summary>
   ///   Price Changes (83)
   /// </summary>
   Seller_PriceChanges_83 = 83,
   /// <summary>
   ///   Earnest Money Check (84)
   /// </summary>
   Seller_EarnestMoneyCheck_84 = 84,
   /// <summary>
   ///   Sales Contract (85)
   /// </summary>
   Seller_SalesContract_85 = 85,
   /// <summary>
   ///   Referral Fee Agreement (86)
   /// </summary>
   Seller_ReferralFeeAgreement_86 = 86,
   /// <summary>
   ///   Signed Disclosures (87)
   /// </summary>
   Seller_SignedDisclosures_87 = 87,
   /// <summary>
   ///   Price Changes (88)
   /// </summary>
   Seller_PriceChanges_88 = 88,
   /// <summary>
   ///   Settlement Statement (89)
   /// </summary>
   Seller_SettlementStatement_89 = 89,
   /// <summary>
   ///   Commission Check/DA (90)
   /// </summary>
   Seller_CommissionCheck_90 = 90,
   /// <summary>
   ///   Earnest Money Check (91)
   /// </summary>
   Seller_EarnestMoneyCheck_91 = 91,
   /// <summary>
   ///   Mutual Cancellation Agreement (92)
   /// </summary>
   Seller_MutualCancellationAgreement_92 = 92,
   /// <summary>
   ///   Additional Files (93)
   /// </summary>
   Seller_AdditionalFiles_93 = 93,
   /// <summary>
   ///   Additional Files (94)
   /// </summary>
   Seller_AdditionalFiles_94 = 94,
   /// <summary>
   ///   Additional Files (95)
   /// </summary>
   Seller_AdditionalFiles_95 = 95,
   /// <summary>
   ///   Agency Agreement (96)
   /// </summary>
   BuyerSeller_AgencyAgreement_96 = 96,
   /// <summary>
   ///   Agency Agreement (97)
   /// </summary>
   BuyerSeller_AgencyAgreement_97 = 97,
   /// <summary>
   ///   Agency Agreement (98)
   /// </summary>
   BuyerSeller_AgencyAgreement_98 = 98,
   /// <summary>
   ///   Sales Contract (99)
   /// </summary>
   BuyerSeller_SalesContract_99 = 99,
   /// <summary>
   ///   MLS Listing Sheet (100)
   /// </summary>
   BuyerSeller_MlsListingSheet_100 = 100,
   /// <summary>
   ///   Referral Fee Agreement (101)
   /// </summary>
   BuyerSeller_ReferralFeeAgreement_101 = 101,
   /// <summary>
   ///   Signed Disclosures (102)
   /// </summary>
   BuyerSeller_SignedDisclosures_102 = 102,
   /// <summary>
   ///   Price Changes (103)
   /// </summary>
   BuyerSeller_PriceChanges_103 = 103,
   /// <summary>
   ///   Earnest Money Check (104)
   /// </summary>
   BuyerSeller_EarnestMoneyCheck_104 = 104,
   /// <summary>
   ///   Commission Check/DA (105)
   /// </summary>
   BuyerSeller_CommissionCheck_105 = 105,
   /// <summary>
   ///   Settlement Statement (106)
   /// </summary>
   BuyerSeller_SettlementStatement_106 = 106,
   /// <summary>
   ///   Sales Contract (107)
   /// </summary>
   BuyerSeller_SalesContract_107 = 107,
   /// <summary>
   ///   Signed Disclosures (108)
   /// </summary>
   BuyerSeller_SignedDisclosures_108 = 108,
   /// <summary>
   ///   Settlement Statement (109)
   /// </summary>
   BuyerSeller_SettlementStatement_109 = 109,
   /// <summary>
   ///   Commission Check/DA (110)
   /// </summary>
   BuyerSeller_CommissionCheck_110 = 110,
   /// <summary>
   ///   Referral Fee Agreement (111)
   /// </summary>
   BuyerSeller_ReferralFeeAgreement_111 = 111,
   /// <summary>
   ///   Price Changes (112)
   /// </summary>
   BuyerSeller_PriceChanges_112 = 112,
   /// <summary>
   ///   Earnest Money Check (113)
   /// </summary>
   BuyerSeller_EarnestMoneyCheck_113 = 113,
   /// <summary>
   ///   Sales Contract (114)
   /// </summary>
   BuyerSeller_SalesContract_114 = 114,
   /// <summary>
   ///   Referral Fee Agreement (115)
   /// </summary>
   BuyerSeller_ReferralFeeAgreement_115 = 115,
   /// <summary>
   ///   Signed Disclosures (116)
   /// </summary>
   BuyerSeller_SignedDisclosures_116 = 116,
   /// <summary>
   ///   Price Changes (117)
   /// </summary>
   BuyerSeller_PriceChanges_117 = 117,
   /// <summary>
   ///   Settlement Statement (118)
   /// </summary>
   BuyerSeller_SettlementStatement_118 = 118,
   /// <summary>
   ///   Commission Check/DA (119)
   /// </summary>
   BuyerSeller_CommissionCheck_119 = 119,
   /// <summary>
   ///   Earnest Money Check (120)
   /// </summary>
   BuyerSeller_EarnestMoneyCheck_120 = 120,
   /// <summary>
   ///   Mutual Cancellation Agreement (121)
   /// </summary>
   BuyerSeller_MutualCancellationAgreement_121 = 121,
   /// <summary>
   ///   Additional Files (122)
   /// </summary>
   BuyerSeller_AdditionalFiles_122 = 122,
   /// <summary>
   ///   Additional Files (123)
   /// </summary>
   BuyerSeller_AdditionalFiles_123 = 123,
   /// <summary>
   ///   Additional Files (124)
   /// </summary>
   BuyerSeller_AdditionalFiles_124 = 124,
   /// <summary>
   ///   Agency Agreement (125)
   /// </summary>
   Landlord_AgencyAgreement_125 = 125,
   /// <summary>
   ///   MLS Listing Sheet (126)
   /// </summary>
   Landlord_MlsListingSheet_126 = 126,
   /// <summary>
   ///   Mutual Cancellation Agreement (127)
   /// </summary>
   Landlord_MutualCancellationAgreement_127 = 127,
   /// <summary>
   ///   Sales Contract (128)
   /// </summary>
   Landlord_SalesContract_128 = 128,
   /// <summary>
   ///   Referral Fee Agreement (129)
   /// </summary>
   Landlord_ReferralFeeAgreement_129 = 129,
   /// <summary>
   ///   Signed Disclosures (130)
   /// </summary>
   Landlord_SignedDisclosures_130 = 130,
   /// <summary>
   ///   Price Changes (131)
   /// </summary>
   Landlord_PriceChanges_131 = 131,
   /// <summary>
   ///   Settlement Statement (132)
   /// </summary>
   Landlord_SettlementStatement_132 = 132,
   /// <summary>
   ///   Commission Check/DA (133)
   /// </summary>
   Landlord_CommissionCheck_133 = 133,
   /// <summary>
   ///   Earnest Money Check (134)
   /// </summary>
   Landlord_EarnestMoneyCheck_134 = 134,
   /// <summary>
   ///   Lease Agreement (135)
   /// </summary>
   Landlord_LeaseAgreement_135 = 135,
   /// <summary>
   ///   MLS Listing Sheet (136)
   /// </summary>
   Landlord_MlsListingSheet_136 = 136,
   /// <summary>
   ///   Commission Check/DA (137)
   /// </summary>
   Landlord_CommissionCheck_137 = 137,
   /// <summary>
   ///   Referral Fee Agreement (138)
   /// </summary>
   Landlord_ReferralFeeAgreement_138 = 138,
   /// <summary>
   ///   Signed Disclosures (139)
   /// </summary>
   Landlord_SignedDisclosures_139 = 139,
   /// <summary>
   ///   Lease Agreement (143)
   /// </summary>
   Landlord_LeaseAgreement_143 = 143,
   /// <summary>
   ///   Lease Agreement (146)
   /// </summary>
   Landlord_LeaseAgreement_146 = 146,
   /// <summary>
   ///   Commission Check/DA (147)
   /// </summary>
   Landlord_CommissionCheck_147 = 147,
   /// <summary>
   ///   Referral Fee Agreement (148)
   /// </summary>
   Landlord_ReferralFeeAgreement_148 = 148,
   /// <summary>
   ///   Signed Disclosures (149)
   /// </summary>
   Landlord_SignedDisclosures_149 = 149,
   /// <summary>
   ///   Lease Agreement (150)
   /// </summary>
   Landlord_LeaseAgreement_150 = 150,
   /// <summary>
   ///   Mutual Cancellation Agreement (151)
   /// </summary>
   Landlord_MutualCancellationAgreement_151 = 151,
   /// <summary>
   ///   Referral Fee Agreement (152)
   /// </summary>
   Landlord_ReferralFeeAgreement_152 = 152,
   /// <summary>
   ///   Signed Disclosures (153)
   /// </summary>
   Landlord_SignedDisclosures_153 = 153,
   /// <summary>
   ///   Commission Check/DA (154)
   /// </summary>
   Landlord_CommissionCheck_154 = 154,
   /// <summary>
   ///   Additional Files (155)
   /// </summary>
   Landlord_AdditionalFiles_155 = 155,
   /// <summary>
   ///   Additional Files (156)
   /// </summary>
   Landlord_AdditionalFiles_156 = 156,
   /// <summary>
   ///   Additional Files (158)
   /// </summary>
   Landlord_AdditionalFiles_158 = 158,
   /// <summary>
   ///   Additional Files (159)
   /// </summary>
   Landlord_AdditionalFiles_159 = 159,
   /// <summary>
   ///   Agency Agreement (160)
   /// </summary>
   Referral_AgencyAgreement_160 = 160,
   /// <summary>
   ///   MLS Listing Sheet (161)
   /// </summary>
   Referral_MlsListingSheet_161 = 161,
   /// <summary>
   ///   Mutual Cancellation Agreement (162)
   /// </summary>
   Referral_MutualCancellationAgreement_162 = 162,
   /// <summary>
   ///   Sales Contract (163)
   /// </summary>
   Referral_SalesContract_163 = 163,
   /// <summary>
   ///   Referral Fee Agreement (164)
   /// </summary>
   Referral_ReferralFeeAgreement_164 = 164,
   /// <summary>
   ///   Signed Disclosures (165)
   /// </summary>
   Referral_SignedDisclosures_165 = 165,
   /// <summary>
   ///   Price Changes (166)
   /// </summary>
   Referral_PriceChanges_166 = 166,
   /// <summary>
   ///   Settlement Statement (167)
   /// </summary>
   Referral_SettlementStatement_167 = 167,
   /// <summary>
   ///   Commission Check/DA (168)
   /// </summary>
   Referral_CommissionCheck_168 = 168,
   /// <summary>
   ///   Earnest Money Check (169)
   /// </summary>
   Referral_EarnestMoneyCheck_169 = 169,
   /// <summary>
   ///   Lease Agreement (170)
   /// </summary>
   Referral_LeaseAgreement_170 = 170,
   /// <summary>
   ///   MLS Listing Sheet (171)
   /// </summary>
   Referral_MlsListingSheet_171 = 171,
   /// <summary>
   ///   Commission Check/DA (172)
   /// </summary>
   Referral_CommissionCheck_172 = 172,
   /// <summary>
   ///   Referral Fee Agreement (173)
   /// </summary>
   Referral_ReferralFeeAgreement_173 = 173,
   /// <summary>
   ///   Signed Disclosures (174)
   /// </summary>
   Referral_SignedDisclosures_174 = 174,
   /// <summary>
   ///   Lease Agreement (175)
   /// </summary>
   Referral_LeaseAgreement_175 = 175,
   /// <summary>
   ///   Lease Agreement (176)
   /// </summary>
   Referral_LeaseAgreement_176 = 176,
   /// <summary>
   ///   Commission Check/DA (177)
   /// </summary>
   Referral_CommissionCheck_177 = 177,
   /// <summary>
   ///   Referral Fee Agreement (178)
   /// </summary>
   Referral_ReferralFeeAgreement_178 = 178,
   /// <summary>
   ///   Signed Disclosures (179)
   /// </summary>
   Referral_SignedDisclosures_179 = 179,
   /// <summary>
   ///   Lease Agreement (180)
   /// </summary>
   Referral_LeaseAgreement_180 = 180,
   /// <summary>
   ///   Mutual Cancellation Agreement (181)
   /// </summary>
   Referral_MutualCancellationAgreement_181 = 181,
   /// <summary>
   ///   Referral Fee Agreement (182)
   /// </summary>
   Referral_ReferralFeeAgreement_182 = 182,
   /// <summary>
   ///   Signed Disclosures (183)
   /// </summary>
   Referral_SignedDisclosures_183 = 183,
   /// <summary>
   ///   Commission Check/DA (184)
   /// </summary>
   Referral_CommissionCheck_184 = 184,
   /// <summary>
   ///   Additional Files (185)
   /// </summary>
   Referral_AdditionalFiles_185 = 185,
   /// <summary>
   ///   Additional Files (186)
   /// </summary>
   Referral_AdditionalFiles_186 = 186,
   /// <summary>
   ///   Additional Files (187)
   /// </summary>
   Referral_AdditionalFiles_187 = 187,
   /// <summary>
   ///   Additional Files (188)
   /// </summary>
   Referral_AdditionalFiles_188 = 188
}

export const DocumentTypeRelevanceTransactionTypeMappings: DocumentTypeRelevanceTransactionTypeMapping[] = [
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AgencyAgreement_3,
      literal: 'Buyer_AgencyAgreement_3',
      description: 'Agency Agreement',
      shortDescription: '3',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_AgencyAgreement_4,
      literal: 'Tenant_AgencyAgreement_4',
      description: 'Agency Agreement',
      shortDescription: '4',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AgencyAgreement_5,
      literal: 'Buyer_AgencyAgreement_5',
      description: 'Agency Agreement',
      shortDescription: '5',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AgencyAgreement_6,
      literal: 'Buyer_AgencyAgreement_6',
      description: 'Agency Agreement',
      shortDescription: '6',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SalesContract_7,
      literal: 'Buyer_SalesContract_7',
      description: 'Sales Contract',
      shortDescription: '7',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_MlsListingSheet_8,
      literal: 'Buyer_MlsListingSheet_8',
      description: 'MLS Listing Sheet',
      shortDescription: '8',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_ReferralFeeAgreement_9,
      literal: 'Buyer_ReferralFeeAgreement_9',
      description: 'Referral Fee Agreement',
      shortDescription: '9',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SignedDisclosures_10,
      literal: 'Buyer_SignedDisclosures_10',
      description: 'Signed Disclosures',
      shortDescription: '10',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_PriceChanges_11,
      literal: 'Buyer_PriceChanges_11',
      description: 'Price Changes',
      shortDescription: '11',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_EarnestMoneyCheck_12,
      literal: 'Buyer_EarnestMoneyCheck_12',
      description: 'Earnest Money Check',
      shortDescription: '12',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_CommissionCheck_13,
      literal: 'Buyer_CommissionCheck_13',
      description: 'Commission Check/DA',
      shortDescription: '13',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SettlementStatement_14,
      literal: 'Buyer_SettlementStatement_14',
      description: 'Settlement Statement',
      shortDescription: '14',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_MlsListingSheet_15,
      literal: 'Tenant_MlsListingSheet_15',
      description: 'MLS Listing Sheet',
      shortDescription: '15',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_MutualCancellationAgreement_16,
      literal: 'Tenant_MutualCancellationAgreement_16',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '16',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SalesContract_17,
      literal: 'Tenant_SalesContract_17',
      description: 'Sales Contract',
      shortDescription: '17',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_ReferralFeeAgreement_18,
      literal: 'Tenant_ReferralFeeAgreement_18',
      description: 'Referral Fee Agreement',
      shortDescription: '18',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SignedDisclosures_19,
      literal: 'Tenant_SignedDisclosures_19',
      description: 'Signed Disclosures',
      shortDescription: '19',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_PriceChanges_20,
      literal: 'Tenant_PriceChanges_20',
      description: 'Price Changes',
      shortDescription: '20',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SettlementStatement_21,
      literal: 'Tenant_SettlementStatement_21',
      description: 'Settlement Statement',
      shortDescription: '21',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_CommissionCheck_22,
      literal: 'Tenant_CommissionCheck_22',
      description: 'Commission Check/DA',
      shortDescription: '22',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_EarnestMoneyCheck_23,
      literal: 'Tenant_EarnestMoneyCheck_23',
      description: 'Earnest Money Check',
      shortDescription: '23',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SalesContract_24,
      literal: 'Buyer_SalesContract_24',
      description: 'Sales Contract',
      shortDescription: '24',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SignedDisclosures_25,
      literal: 'Buyer_SignedDisclosures_25',
      description: 'Signed Disclosures',
      shortDescription: '25',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SettlementStatement_26,
      literal: 'Buyer_SettlementStatement_26',
      description: 'Settlement Statement',
      shortDescription: '26',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_CommissionCheck_27,
      literal: 'Buyer_CommissionCheck_27',
      description: 'Commission Check/DA',
      shortDescription: '27',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_ReferralFeeAgreement_28,
      literal: 'Buyer_ReferralFeeAgreement_28',
      description: 'Referral Fee Agreement',
      shortDescription: '28',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_PriceChanges_29,
      literal: 'Buyer_PriceChanges_29',
      description: 'Price Changes',
      shortDescription: '29',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_EarnestMoneyCheck_30,
      literal: 'Buyer_EarnestMoneyCheck_30',
      description: 'Earnest Money Check',
      shortDescription: '30',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SalesContract_31,
      literal: 'Buyer_SalesContract_31',
      description: 'Sales Contract',
      shortDescription: '31',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_ReferralFeeAgreement_32,
      literal: 'Buyer_ReferralFeeAgreement_32',
      description: 'Referral Fee Agreement',
      shortDescription: '32',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SignedDisclosures_33,
      literal: 'Buyer_SignedDisclosures_33',
      description: 'Signed Disclosures',
      shortDescription: '33',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_PriceChanges_34,
      literal: 'Buyer_PriceChanges_34',
      description: 'Price Changes',
      shortDescription: '34',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_SettlementStatement_35,
      literal: 'Buyer_SettlementStatement_35',
      description: 'Settlement Statement',
      shortDescription: '35',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_CommissionCheck_36,
      literal: 'Buyer_CommissionCheck_36',
      description: 'Commission Check/DA',
      shortDescription: '36',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_EarnestMoneyCheck_37,
      literal: 'Buyer_EarnestMoneyCheck_37',
      description: 'Earnest Money Check',
      shortDescription: '37',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_MutualCancellationAgreement_38,
      literal: 'Buyer_MutualCancellationAgreement_38',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '38',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_LeaseAgreement_39,
      literal: 'Tenant_LeaseAgreement_39',
      description: 'Lease Agreement',
      shortDescription: '39',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_MlsListingSheet_40,
      literal: 'Tenant_MlsListingSheet_40',
      description: 'MLS Listing Sheet',
      shortDescription: '40',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_CommissionCheck_41,
      literal: 'Tenant_CommissionCheck_41',
      description: 'Commission Check/DA',
      shortDescription: '41',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_ReferralFeeAgreement_42,
      literal: 'Tenant_ReferralFeeAgreement_42',
      description: 'Referral Fee Agreement',
      shortDescription: '42',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SignedDisclosures_43,
      literal: 'Tenant_SignedDisclosures_43',
      description: 'Signed Disclosures',
      shortDescription: '43',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_LeaseAgreement_47,
      literal: 'Tenant_LeaseAgreement_47',
      description: 'Lease Agreement',
      shortDescription: '47',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_LeaseAgreement_50,
      literal: 'Tenant_LeaseAgreement_50',
      description: 'Lease Agreement',
      shortDescription: '50',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_CommissionCheck_51,
      literal: 'Tenant_CommissionCheck_51',
      description: 'Commission Check/DA',
      shortDescription: '51',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_ReferralFeeAgreement_52,
      literal: 'Tenant_ReferralFeeAgreement_52',
      description: 'Referral Fee Agreement',
      shortDescription: '52',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SignedDisclosures_53,
      literal: 'Tenant_SignedDisclosures_53',
      description: 'Signed Disclosures',
      shortDescription: '53',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_LeaseAgreement_54,
      literal: 'Tenant_LeaseAgreement_54',
      description: 'Lease Agreement',
      shortDescription: '54',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_MutualCancellationAgreement_55,
      literal: 'Tenant_MutualCancellationAgreement_55',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '55',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_ReferralFeeAgreement_56,
      literal: 'Tenant_ReferralFeeAgreement_56',
      description: 'Referral Fee Agreement',
      shortDescription: '56',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_SignedDisclosures_57,
      literal: 'Tenant_SignedDisclosures_57',
      description: 'Signed Disclosures',
      shortDescription: '57',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_CommissionCheck_58,
      literal: 'Tenant_CommissionCheck_58',
      description: 'Commission Check/DA',
      shortDescription: '58',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AdditionalFiles_59,
      literal: 'Buyer_AdditionalFiles_59',
      description: 'Additional Files',
      shortDescription: '59',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 1,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_AdditionalFiles_60,
      literal: 'Tenant_AdditionalFiles_60',
      description: 'Additional Files',
      shortDescription: '60',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AdditionalFiles_61,
      literal: 'Buyer_AdditionalFiles_61',
      description: 'Additional Files',
      shortDescription: '61',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Buyer_AdditionalFiles_62,
      literal: 'Buyer_AdditionalFiles_62',
      description: 'Additional Files',
      shortDescription: '62',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 1,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_AdditionalFiles_63,
      literal: 'Tenant_AdditionalFiles_63',
      description: 'Additional Files',
      shortDescription: '63',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 4,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_AdditionalFiles_65,
      literal: 'Tenant_AdditionalFiles_65',
      description: 'Additional Files',
      shortDescription: '65',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Tenant_AdditionalFiles_66,
      literal: 'Tenant_AdditionalFiles_66',
      description: 'Additional Files',
      shortDescription: '66',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 4,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AgencyAgreement_67,
      literal: 'Seller_AgencyAgreement_67',
      description: 'Agency Agreement',
      shortDescription: '67',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AgencyAgreement_68,
      literal: 'Seller_AgencyAgreement_68',
      description: 'Agency Agreement',
      shortDescription: '68',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AgencyAgreement_69,
      literal: 'Seller_AgencyAgreement_69',
      description: 'Agency Agreement',
      shortDescription: '69',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SalesContract_70,
      literal: 'Seller_SalesContract_70',
      description: 'Sales Contract',
      shortDescription: '70',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_MlsListingSheet_71,
      literal: 'Seller_MlsListingSheet_71',
      description: 'MLS Listing Sheet',
      shortDescription: '71',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_ReferralFeeAgreement_72,
      literal: 'Seller_ReferralFeeAgreement_72',
      description: 'Referral Fee Agreement',
      shortDescription: '72',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SignedDisclosures_73,
      literal: 'Seller_SignedDisclosures_73',
      description: 'Signed Disclosures',
      shortDescription: '73',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_PriceChanges_74,
      literal: 'Seller_PriceChanges_74',
      description: 'Price Changes',
      shortDescription: '74',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_EarnestMoneyCheck_75,
      literal: 'Seller_EarnestMoneyCheck_75',
      description: 'Earnest Money Check',
      shortDescription: '75',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_CommissionCheck_76,
      literal: 'Seller_CommissionCheck_76',
      description: 'Commission Check/DA',
      shortDescription: '76',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SettlementStatement_77,
      literal: 'Seller_SettlementStatement_77',
      description: 'Settlement Statement',
      shortDescription: '77',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SalesContract_78,
      literal: 'Seller_SalesContract_78',
      description: 'Sales Contract',
      shortDescription: '78',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SignedDisclosures_79,
      literal: 'Seller_SignedDisclosures_79',
      description: 'Signed Disclosures',
      shortDescription: '79',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SettlementStatement_80,
      literal: 'Seller_SettlementStatement_80',
      description: 'Settlement Statement',
      shortDescription: '80',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_CommissionCheck_81,
      literal: 'Seller_CommissionCheck_81',
      description: 'Commission Check/DA',
      shortDescription: '81',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_ReferralFeeAgreement_82,
      literal: 'Seller_ReferralFeeAgreement_82',
      description: 'Referral Fee Agreement',
      shortDescription: '82',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_PriceChanges_83,
      literal: 'Seller_PriceChanges_83',
      description: 'Price Changes',
      shortDescription: '83',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_EarnestMoneyCheck_84,
      literal: 'Seller_EarnestMoneyCheck_84',
      description: 'Earnest Money Check',
      shortDescription: '84',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SalesContract_85,
      literal: 'Seller_SalesContract_85',
      description: 'Sales Contract',
      shortDescription: '85',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_ReferralFeeAgreement_86,
      literal: 'Seller_ReferralFeeAgreement_86',
      description: 'Referral Fee Agreement',
      shortDescription: '86',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SignedDisclosures_87,
      literal: 'Seller_SignedDisclosures_87',
      description: 'Signed Disclosures',
      shortDescription: '87',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_PriceChanges_88,
      literal: 'Seller_PriceChanges_88',
      description: 'Price Changes',
      shortDescription: '88',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_SettlementStatement_89,
      literal: 'Seller_SettlementStatement_89',
      description: 'Settlement Statement',
      shortDescription: '89',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_CommissionCheck_90,
      literal: 'Seller_CommissionCheck_90',
      description: 'Commission Check/DA',
      shortDescription: '90',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_EarnestMoneyCheck_91,
      literal: 'Seller_EarnestMoneyCheck_91',
      description: 'Earnest Money Check',
      shortDescription: '91',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_MutualCancellationAgreement_92,
      literal: 'Seller_MutualCancellationAgreement_92',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '92',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AdditionalFiles_93,
      literal: 'Seller_AdditionalFiles_93',
      description: 'Additional Files',
      shortDescription: '93',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 2,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AdditionalFiles_94,
      literal: 'Seller_AdditionalFiles_94',
      description: 'Additional Files',
      shortDescription: '94',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Seller_AdditionalFiles_95,
      literal: 'Seller_AdditionalFiles_95',
      description: 'Additional Files',
      shortDescription: '95',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 2,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AgencyAgreement_96,
      literal: 'BuyerSeller_AgencyAgreement_96',
      description: 'Agency Agreement',
      shortDescription: '96',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AgencyAgreement_97,
      literal: 'BuyerSeller_AgencyAgreement_97',
      description: 'Agency Agreement',
      shortDescription: '97',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AgencyAgreement_98,
      literal: 'BuyerSeller_AgencyAgreement_98',
      description: 'Agency Agreement',
      shortDescription: '98',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SalesContract_99,
      literal: 'BuyerSeller_SalesContract_99',
      description: 'Sales Contract',
      shortDescription: '99',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_MlsListingSheet_100,
      literal: 'BuyerSeller_MlsListingSheet_100',
      description: 'MLS Listing Sheet',
      shortDescription: '100',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_ReferralFeeAgreement_101,
      literal: 'BuyerSeller_ReferralFeeAgreement_101',
      description: 'Referral Fee Agreement',
      shortDescription: '101',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SignedDisclosures_102,
      literal: 'BuyerSeller_SignedDisclosures_102',
      description: 'Signed Disclosures',
      shortDescription: '102',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_PriceChanges_103,
      literal: 'BuyerSeller_PriceChanges_103',
      description: 'Price Changes',
      shortDescription: '103',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_EarnestMoneyCheck_104,
      literal: 'BuyerSeller_EarnestMoneyCheck_104',
      description: 'Earnest Money Check',
      shortDescription: '104',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_CommissionCheck_105,
      literal: 'BuyerSeller_CommissionCheck_105',
      description: 'Commission Check/DA',
      shortDescription: '105',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SettlementStatement_106,
      literal: 'BuyerSeller_SettlementStatement_106',
      description: 'Settlement Statement',
      shortDescription: '106',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SalesContract_107,
      literal: 'BuyerSeller_SalesContract_107',
      description: 'Sales Contract',
      shortDescription: '107',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SignedDisclosures_108,
      literal: 'BuyerSeller_SignedDisclosures_108',
      description: 'Signed Disclosures',
      shortDescription: '108',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SettlementStatement_109,
      literal: 'BuyerSeller_SettlementStatement_109',
      description: 'Settlement Statement',
      shortDescription: '109',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_CommissionCheck_110,
      literal: 'BuyerSeller_CommissionCheck_110',
      description: 'Commission Check/DA',
      shortDescription: '110',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_ReferralFeeAgreement_111,
      literal: 'BuyerSeller_ReferralFeeAgreement_111',
      description: 'Referral Fee Agreement',
      shortDescription: '111',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_PriceChanges_112,
      literal: 'BuyerSeller_PriceChanges_112',
      description: 'Price Changes',
      shortDescription: '112',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_EarnestMoneyCheck_113,
      literal: 'BuyerSeller_EarnestMoneyCheck_113',
      description: 'Earnest Money Check',
      shortDescription: '113',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SalesContract_114,
      literal: 'BuyerSeller_SalesContract_114',
      description: 'Sales Contract',
      shortDescription: '114',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_ReferralFeeAgreement_115,
      literal: 'BuyerSeller_ReferralFeeAgreement_115',
      description: 'Referral Fee Agreement',
      shortDescription: '115',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SignedDisclosures_116,
      literal: 'BuyerSeller_SignedDisclosures_116',
      description: 'Signed Disclosures',
      shortDescription: '116',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_PriceChanges_117,
      literal: 'BuyerSeller_PriceChanges_117',
      description: 'Price Changes',
      shortDescription: '117',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_SettlementStatement_118,
      literal: 'BuyerSeller_SettlementStatement_118',
      description: 'Settlement Statement',
      shortDescription: '118',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_CommissionCheck_119,
      literal: 'BuyerSeller_CommissionCheck_119',
      description: 'Commission Check/DA',
      shortDescription: '119',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_EarnestMoneyCheck_120,
      literal: 'BuyerSeller_EarnestMoneyCheck_120',
      description: 'Earnest Money Check',
      shortDescription: '120',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_MutualCancellationAgreement_121,
      literal: 'BuyerSeller_MutualCancellationAgreement_121',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '121',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AdditionalFiles_122,
      literal: 'BuyerSeller_AdditionalFiles_122',
      description: 'Additional Files',
      shortDescription: '122',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 3,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AdditionalFiles_123,
      literal: 'BuyerSeller_AdditionalFiles_123',
      description: 'Additional Files',
      shortDescription: '123',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.BuyerSeller_AdditionalFiles_124,
      literal: 'BuyerSeller_AdditionalFiles_124',
      description: 'Additional Files',
      shortDescription: '124',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 3,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_AgencyAgreement_125,
      literal: 'Landlord_AgencyAgreement_125',
      description: 'Agency Agreement',
      shortDescription: '125',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_MlsListingSheet_126,
      literal: 'Landlord_MlsListingSheet_126',
      description: 'MLS Listing Sheet',
      shortDescription: '126',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_MutualCancellationAgreement_127,
      literal: 'Landlord_MutualCancellationAgreement_127',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '127',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SalesContract_128,
      literal: 'Landlord_SalesContract_128',
      description: 'Sales Contract',
      shortDescription: '128',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_ReferralFeeAgreement_129,
      literal: 'Landlord_ReferralFeeAgreement_129',
      description: 'Referral Fee Agreement',
      shortDescription: '129',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SignedDisclosures_130,
      literal: 'Landlord_SignedDisclosures_130',
      description: 'Signed Disclosures',
      shortDescription: '130',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_PriceChanges_131,
      literal: 'Landlord_PriceChanges_131',
      description: 'Price Changes',
      shortDescription: '131',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SettlementStatement_132,
      literal: 'Landlord_SettlementStatement_132',
      description: 'Settlement Statement',
      shortDescription: '132',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_CommissionCheck_133,
      literal: 'Landlord_CommissionCheck_133',
      description: 'Commission Check/DA',
      shortDescription: '133',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_EarnestMoneyCheck_134,
      literal: 'Landlord_EarnestMoneyCheck_134',
      description: 'Earnest Money Check',
      shortDescription: '134',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_LeaseAgreement_135,
      literal: 'Landlord_LeaseAgreement_135',
      description: 'Lease Agreement',
      shortDescription: '135',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_MlsListingSheet_136,
      literal: 'Landlord_MlsListingSheet_136',
      description: 'MLS Listing Sheet',
      shortDescription: '136',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_CommissionCheck_137,
      literal: 'Landlord_CommissionCheck_137',
      description: 'Commission Check/DA',
      shortDescription: '137',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_ReferralFeeAgreement_138,
      literal: 'Landlord_ReferralFeeAgreement_138',
      description: 'Referral Fee Agreement',
      shortDescription: '138',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SignedDisclosures_139,
      literal: 'Landlord_SignedDisclosures_139',
      description: 'Signed Disclosures',
      shortDescription: '139',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_LeaseAgreement_143,
      literal: 'Landlord_LeaseAgreement_143',
      description: 'Lease Agreement',
      shortDescription: '143',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_LeaseAgreement_146,
      literal: 'Landlord_LeaseAgreement_146',
      description: 'Lease Agreement',
      shortDescription: '146',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_CommissionCheck_147,
      literal: 'Landlord_CommissionCheck_147',
      description: 'Commission Check/DA',
      shortDescription: '147',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_ReferralFeeAgreement_148,
      literal: 'Landlord_ReferralFeeAgreement_148',
      description: 'Referral Fee Agreement',
      shortDescription: '148',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SignedDisclosures_149,
      literal: 'Landlord_SignedDisclosures_149',
      description: 'Signed Disclosures',
      shortDescription: '149',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_LeaseAgreement_150,
      literal: 'Landlord_LeaseAgreement_150',
      description: 'Lease Agreement',
      shortDescription: '150',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_MutualCancellationAgreement_151,
      literal: 'Landlord_MutualCancellationAgreement_151',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '151',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_ReferralFeeAgreement_152,
      literal: 'Landlord_ReferralFeeAgreement_152',
      description: 'Referral Fee Agreement',
      shortDescription: '152',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_SignedDisclosures_153,
      literal: 'Landlord_SignedDisclosures_153',
      description: 'Signed Disclosures',
      shortDescription: '153',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_CommissionCheck_154,
      literal: 'Landlord_CommissionCheck_154',
      description: 'Commission Check/DA',
      shortDescription: '154',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_AdditionalFiles_155,
      literal: 'Landlord_AdditionalFiles_155',
      description: 'Additional Files',
      shortDescription: '155',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_AdditionalFiles_156,
      literal: 'Landlord_AdditionalFiles_156',
      description: 'Additional Files',
      shortDescription: '156',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 5,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_AdditionalFiles_158,
      literal: 'Landlord_AdditionalFiles_158',
      description: 'Additional Files',
      shortDescription: '158',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Landlord_AdditionalFiles_159,
      literal: 'Landlord_AdditionalFiles_159',
      description: 'Additional Files',
      shortDescription: '159',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 5,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_AgencyAgreement_160,
      literal: 'Referral_AgencyAgreement_160',
      description: 'Agency Agreement',
      shortDescription: '160',
      listPriority: 0,

      documentTypeCode: 1,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_MlsListingSheet_161,
      literal: 'Referral_MlsListingSheet_161',
      description: 'MLS Listing Sheet',
      shortDescription: '161',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_MutualCancellationAgreement_162,
      literal: 'Referral_MutualCancellationAgreement_162',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '162',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SalesContract_163,
      literal: 'Referral_SalesContract_163',
      description: 'Sales Contract',
      shortDescription: '163',
      listPriority: 0,

      documentTypeCode: 3,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_ReferralFeeAgreement_164,
      literal: 'Referral_ReferralFeeAgreement_164',
      description: 'Referral Fee Agreement',
      shortDescription: '164',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SignedDisclosures_165,
      literal: 'Referral_SignedDisclosures_165',
      description: 'Signed Disclosures',
      shortDescription: '165',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_PriceChanges_166,
      literal: 'Referral_PriceChanges_166',
      description: 'Price Changes',
      shortDescription: '166',
      listPriority: 0,

      documentTypeCode: 7,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SettlementStatement_167,
      literal: 'Referral_SettlementStatement_167',
      description: 'Settlement Statement',
      shortDescription: '167',
      listPriority: 0,

      documentTypeCode: 8,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_CommissionCheck_168,
      literal: 'Referral_CommissionCheck_168',
      description: 'Commission Check/DA',
      shortDescription: '168',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_EarnestMoneyCheck_169,
      literal: 'Referral_EarnestMoneyCheck_169',
      description: 'Earnest Money Check',
      shortDescription: '169',
      listPriority: 0,

      documentTypeCode: 10,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_LeaseAgreement_170,
      literal: 'Referral_LeaseAgreement_170',
      description: 'Lease Agreement',
      shortDescription: '170',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_MlsListingSheet_171,
      literal: 'Referral_MlsListingSheet_171',
      description: 'MLS Listing Sheet',
      shortDescription: '171',
      listPriority: 0,

      documentTypeCode: 4,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_CommissionCheck_172,
      literal: 'Referral_CommissionCheck_172',
      description: 'Commission Check/DA',
      shortDescription: '172',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_ReferralFeeAgreement_173,
      literal: 'Referral_ReferralFeeAgreement_173',
      description: 'Referral Fee Agreement',
      shortDescription: '173',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SignedDisclosures_174,
      literal: 'Referral_SignedDisclosures_174',
      description: 'Signed Disclosures',
      shortDescription: '174',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_LeaseAgreement_175,
      literal: 'Referral_LeaseAgreement_175',
      description: 'Lease Agreement',
      shortDescription: '175',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_LeaseAgreement_176,
      literal: 'Referral_LeaseAgreement_176',
      description: 'Lease Agreement',
      shortDescription: '176',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_CommissionCheck_177,
      literal: 'Referral_CommissionCheck_177',
      description: 'Commission Check/DA',
      shortDescription: '177',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_ReferralFeeAgreement_178,
      literal: 'Referral_ReferralFeeAgreement_178',
      description: 'Referral Fee Agreement',
      shortDescription: '178',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: false,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SignedDisclosures_179,
      literal: 'Referral_SignedDisclosures_179',
      description: 'Signed Disclosures',
      shortDescription: '179',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_LeaseAgreement_180,
      literal: 'Referral_LeaseAgreement_180',
      description: 'Lease Agreement',
      shortDescription: '180',
      listPriority: 0,

      documentTypeCode: 2,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_MutualCancellationAgreement_181,
      literal: 'Referral_MutualCancellationAgreement_181',
      description: 'Mutual Cancellation Agreement',
      shortDescription: '181',
      listPriority: 0,

      documentTypeCode: 11,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_ReferralFeeAgreement_182,
      literal: 'Referral_ReferralFeeAgreement_182',
      description: 'Referral Fee Agreement',
      shortDescription: '182',
      listPriority: 0,

      documentTypeCode: 5,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_SignedDisclosures_183,
      literal: 'Referral_SignedDisclosures_183',
      description: 'Signed Disclosures',
      shortDescription: '183',
      listPriority: 0,

      documentTypeCode: 6,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_CommissionCheck_184,
      literal: 'Referral_CommissionCheck_184',
      description: 'Commission Check/DA',
      shortDescription: '184',
      listPriority: 0,

      documentTypeCode: 9,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: true,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_AdditionalFiles_185,
      literal: 'Referral_AdditionalFiles_185',
      description: 'Additional Files',
      shortDescription: '185',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_AdditionalFiles_186,
      literal: 'Referral_AdditionalFiles_186',
      description: 'Additional Files',
      shortDescription: '186',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 6,

      hasMLS: true,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_AdditionalFiles_187,
      literal: 'Referral_AdditionalFiles_187',
      description: 'Additional Files',
      shortDescription: '187',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: false,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   },
   {
      code: DocumentTypeRelevanceTransactionTypeMapping_.Referral_AdditionalFiles_188,
      literal: 'Referral_AdditionalFiles_188',
      description: 'Additional Files',
      shortDescription: '188',
      listPriority: 9,

      documentTypeCode: 12,

      transactionTypeCode: 6,

      hasMLS: false,

      isCancelled: true,

      isRequired: false,

      typeName: "DocumentTypeRelevanceTransactionTypeMapping"
   }
]

export class DocumentTypeRelevanceTransactionTypeMapping implements IDomainModel {
   code: DocumentTypeRelevanceTransactionTypeMapping_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   documentTypeCode: number

   transactionTypeCode: number

   hasMLS: boolean

   isCancelled: boolean

   isRequired: boolean

   typeName: string

   static toDomainModel(code: DocumentTypeRelevanceTransactionTypeMapping_): DocumentTypeRelevanceTransactionTypeMapping {
      return DocumentTypeRelevanceTransactionTypeMappings.find(d => d.code === code)
   }
}
